export default __webpack_public_path__ + "static/media/icon-arrow-back.3b485f89.svg";